export default __webpack_public_path__ + "static/media/05bg.a72f0170.png";